let mapStyleStreet = 'mapbox://styles/mapbox/streets-v11';
let mapStyleSatelite = 'mapbox://styles/mapbox/satellite-v9';
let mapStyleDark = 'mapbox://styles/mapbox/dark-v10';

export {mapStyleDark, mapStyleSatelite, mapStyleStreet};